import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable prettier/prettier */
import { Button, Image } from "@outdoor-voices/ui";
import { isTabletSmall, isMobileLarge } from "@outdoor-voices/ui/dist/utils/dom/isMobile";
import { useEffect, useState } from "react";
import cc from "classcat";
import PropTypes from "prop-types";
import { RESIZE } from "../../../config/constants";
import css from "./index.module.scss";
import newLineToBreakTag from "../../../utils/strings/newLineToBreakTag";
import Video from "../../../components/Video";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var sizes = [480, 600, 900, 1200, 1400];
var BlockType = PropTypes.shape({
  cta: PropTypes.string,
  ctaExtra: PropTypes.string,
  image: PropTypes.shape({}),
  rawHtml: PropTypes.string,
  subtitle: PropTypes.string,
  subtitleColor: PropTypes.string,
  title: PropTypes.string,
  titleColor: PropTypes.string,
  url: PropTypes.string,
  urlExtra: PropTypes.string,
  video: PropTypes.shape({
    poster: PropTypes.shape({
      src: PropTypes.string
    }),
    track: PropTypes.string
  })
});
var HeroType = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(BlockType)
  }),
  lazyload: PropTypes.bool
};

var Block = function Block(_ref) {
  var node = _ref.node,
      lazyload = _ref.lazyload;
  var cta = node.cta,
      ctaExtra = node.ctaExtra,
      image = node.image,
      rawHtml = node.rawHtml,
      subtitle = node.subtitle,
      subtitleColor = node.subtitleColor,
      title = node.title,
      titleColor = node.titleColor,
      url = node.url,
      urlExtra = node.urlExtra,
      video = node.video;
  var hasCta = !!cta && !!url;
  var hasCtaExtra = !!ctaExtra && !!urlExtra;

  if (rawHtml) {
    return /*#__PURE__*/_jsx("div", {
      className: css.root,
      dangerouslySetInnerHTML: {
        __html: rawHtml
      }
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [image && /*#__PURE__*/_jsx("div", {
      className: css.image,
      children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
        lazyload: lazyload,
        sizes: sizes
      }))
    }), video && /*#__PURE__*/_jsx(Video, _objectSpread(_objectSpread({}, video), {}, {
      poster: video.poster.src,
      track: video.track
    })), /*#__PURE__*/_jsxs("div", {
      className: css.text,
      children: [/*#__PURE__*/_jsxs("div", {
        children: [title && /*#__PURE__*/_jsx("h1", {
          className: css.title,
          dangerouslySetInnerHTML: {
            __html: newLineToBreakTag(title)
          },
          style: {
            color: titleColor
          }
        }), subtitle && /*#__PURE__*/_jsx("h2", {
          className: css.subtitle,
          dangerouslySetInnerHTML: {
            __html: newLineToBreakTag(subtitle)
          },
          style: {
            color: subtitleColor
          }
        })]
      }), (hasCta || hasCtaExtra) && /*#__PURE__*/_jsxs("div", {
        className: css.ctas,
        children: [hasCta && /*#__PURE__*/_jsx("div", {
          className: css.cta,
          children: /*#__PURE__*/_jsx(Button, {
            big: true,
            full: true,
            href: url,
            children: cta
          })
        }), hasCtaExtra && /*#__PURE__*/_jsx("div", {
          className: css.cta,
          children: /*#__PURE__*/_jsx(Button, {
            big: true,
            full: true,
            href: urlExtra,
            children: ctaExtra
          })
        })]
      })]
    })]
  });
};

Block.propTypes = {
  node: BlockType,
  lazyload: PropTypes.bool
};

var Two = function Two(_ref2) {
  var blocks = _ref2.blocks,
      lazyload = _ref2.lazyload;
  return /*#__PURE__*/_jsx("section", {
    className: cc([css.root, css.two]),
    children: blocks.edges.map(function (_ref3) {
      var node = _ref3.node;
      return /*#__PURE__*/_jsx("div", {
        className: css.block,
        children: /*#__PURE__*/_jsx(Block, {
          lazyload: lazyload,
          node: node
        })
      }, node.id);
    })
  });
};

Two.propTypes = HeroType;
var mobile = "mobile";
var tablet = "tablet";
var desktop = "desktop";

var Default = function Default(_ref4) {
  var blocks = _ref4.blocks,
      lazyload = _ref4.lazyload;

  var _useState = useState(isMobileLarge() ? mobile : isTabletSmall() ? tablet : desktop),
      _useState2 = _slicedToArray(_useState, 2),
      type = _useState2[0],
      setType = _useState2[1];

  useEffect(function () {
    var onResize = function onResize() {
      /* eslint-disable */
      var newType = isMobileLarge() ? mobile : isTabletSmall() ? tablet : desktop;
      /* eslint-enable */

      if (newType === type) {
        return;
      }

      setType(newType);
    };

    window.addEventListener(RESIZE, onResize);
    return function () {
      window.removeEventListener(RESIZE, onResize);
    };
  }, [type]);
  var block = blocks.edges.find(function (_ref5) {
    var blockType = _ref5.node.blockType;
    return blockType.toLowerCase() === type;
  }) || blocks.edges[0];
  return /*#__PURE__*/_jsx("section", {
    className: css.root,
    children: /*#__PURE__*/_jsx(Block, {
      lazyload: lazyload,
      node: block.node
    })
  });
};

Default.propTypes = HeroType;
export var Hero = function Hero(_ref6) {
  var blocks = _ref6.blocks,
      lazyload = _ref6.lazyload;

  // Bail out at two.
  if (blocks.edges.length === 2) {
    return /*#__PURE__*/_jsx(Two, {
      blocks: blocks,
      lazyload: lazyload
    });
  }

  return /*#__PURE__*/_jsx(Default, {
    blocks: blocks,
    lazyload: lazyload
  });
};
Hero.propTypes = HeroType;